export const getSegmentValues = (view, segment, mode) => {
    const valueModel = view.get(segment).values.get(mode);
    if (!valueModel) {
        throw `No value found in segment: ${segment} by mode: ${mode}`;
    }
    return valueModel.get();
};
